export default "__VITE_ASSET__DH41O$ab__"